import { ILabel, SavedLabel } from '../../types';
import { getVerbWidth } from '../../utils';

export const LIMIT_DRAG_ELEMENTS = 20;
const DEFAULT_POSITION_X = 94.81641468682506;
const DEFAULT_POSITION_Y = 6.120826709062003;
export const DEFAULT_POSITION = { x: DEFAULT_POSITION_X, y: DEFAULT_POSITION_Y };

export const insertDraggableElement = (
  labels: Array<ILabel>,
  setLabels: (labels: Array<ILabel | SavedLabel>) => void,
  saveLabelsUpdates: (prevState: ILabel[] | SavedLabel[], state: ILabel[] | SavedLabel[]) => void,
  text: string,
  editMode: boolean
): void => {
  if (labels.length >= LIMIT_DRAG_ELEMENTS) {
    return;
  }

  const newLabel = {
    text: text,
    selectionRange: {
      width: getVerbWidth(text),
      selectionStart: 0,
    },
    position: DEFAULT_POSITION,
    id: getMaxId(labels) + 1,
    isHidden: false,
    isFocussed: true,
    isManuallyHidden: false,
    isHighlighted: false,
  };

  const payload = [...labels, newLabel];
  setLabels(payload);
  editMode && saveLabelsUpdates(labels, payload);
};

const getMaxId = (labels: Array<ILabel>): number => {
  let max = { id: 0 };

  if (labels.length != 0) {
    max = labels.reduce((prev, current: ILabel) => {
      return prev.id > current.id ? prev : current;
    });
  }

  return max.id;
};
